import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useColumns = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            header: t("name"),
            name: "search",
            alwaysVisible: true,
        },
        {
            header: t("summary"),
            name: "summary",
        }
    ], [t]);
}
